import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as moment from 'moment';

export const DATE_VALUES = {
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY'
  },
};

@Component({
  selector: 'insert-edit-year-month',
  templateUrl: './year-month.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: DATE_VALUES },
    { provide: DateAdapter, useClass: MomentDateAdapter }
  ]
})
export class YearMonthComponent implements OnInit {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() required: boolean = false;

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnInit() {
    const v = this.getFormControlField()?.value;

    if(v !== null && v !== '') {
      this.getFormControlField()?.setValue(moment(v, 'YYYYMM'));
    }
  }

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

  clearField() {
    this.getFormControlField()?.setValue(null);
  }

  onYearSelected(year: moment.Moment) {
    this.getFormControlField()?.setValue(year);
  }

  onMonthSelected(normalizedMonth: moment.Moment, datepicker: MatDatepicker<moment.Moment>) {
    const ctrlValue: moment.Moment = this.getFormControlField()?.value;
    ctrlValue.month(normalizedMonth.month());
    this.getFormControlField()?.setValue(ctrlValue);
    datepicker.close();
  }
}
